import React, { useState, useEffect } from "react";
import { ThemeCtx, ToastCtx, api, SEV_C, STAT_C, PAGE_SIZE, Pager, Card, Modal, Bdg, Dot, Av, AdminBadge, useToast, ConfirmDialog, usePagination } from "../shared.js";

export function EOLLeadershipCard(){
  var T=React.useContext(ThemeCtx).T;
  var _data=useState(null); var data=_data[0]; var setData=_data[1];
  var PURPLE="#A100FF";

  useEffect(function(){
    api.get("/eol/summary").then(setData).catch(function(){});
  },[]);

  if(!data) return null;

  var pct=data.total>0?Math.round((data.expired/data.total)*100):0;

  return React.createElement("div",{style:{background:T.card,border:"1px solid "+T.border,padding:"14px 16px"}},
    React.createElement("div",{style:{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}},
      React.createElement("div",{style:{fontSize:13,fontWeight:600,color:T.text,textTransform:"uppercase",letterSpacing:.5}},"EOL / EOS Software"),
      React.createElement("div",{style:{fontSize:11,color:T.text3}},data.total+" products tracked")
    ),
    React.createElement("div",{style:{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:8,marginBottom:12}},
      [
        {l:"Expired",v:data.expired,c:"#ef4444"},
        {l:"Expiring <90d",v:data.expiring_soon,c:"#f97316"},
        {l:"Future",v:data.future,c:"#22c55e"},
      ].map(function(s){
        return React.createElement("div",{key:s.l,style:{background:T.inset,padding:"10px 12px",textAlign:"center"}},
          React.createElement("div",{style:{fontSize:22,fontWeight:800,color:s.c,lineHeight:1}},s.v),
          React.createElement("div",{style:{fontSize:10,color:T.text3,marginTop:3,textTransform:"uppercase",letterSpacing:.5}},s.l)
        );
      })
    ),
    React.createElement("div",null,
      React.createElement("div",{style:{display:"flex",justifyContent:"space-between",fontSize:11,marginBottom:4}},
        React.createElement("span",{style:{color:T.text2}},"EOL Exposure"),
        React.createElement("span",{style:{color:"#ef4444",fontWeight:700}},pct+"%")
      ),
      React.createElement("div",{style:{height:8,background:T.inset,overflow:"hidden",borderRadius:4}},
        React.createElement("div",{style:{width:pct+"%",height:"100%",
          background:pct>70?"#ef4444":pct>40?"#f97316":"#22c55e",
          transition:"width .5s",borderRadius:4}})
      ),
      React.createElement("div",{style:{fontSize:10,color:T.text3,marginTop:4}},
        pct>70?"High exposure — immediate attention required":
        pct>40?"Moderate exposure — plan upgrades":
        "Low exposure — good hygiene"
      )
    )
  );
}


export function PageEOL(){
  var T=React.useContext(ThemeCtx).T;
  var _data=useState([]); var data=_data[0]; var setData=_data[1];
  var _summary=useState(null); var summary=_summary[0]; var setSummary=_summary[1];
  var _loading=useState(true); var loading=_loading[0]; var setLoading=_loading[1];
  var _filter=useState("all"); var filter=_filter[0]; var setFilter=_filter[1];
  var _search=useState(""); var search=_search[0]; var setSearch=_search[1];
  var PURPLE="#A100FF";

  useEffect(function(){
    Promise.all([api.get("/eol"),api.get("/eol/summary")])
      .then(function(r){setData(r[0]);setSummary(r[1]);setLoading(false);})
      .catch(function(){setLoading(false);});
  },[]);

  var filtered=data.filter(function(d){
    if(filter==="expired" && !d.is_eol) return false;
    if(filter==="soon"    && (d.is_eol||!d.days_to_eol||d.days_to_eol>90)) return false;
    if(filter==="ok"      && (d.is_eol||d.days_to_eol<=90)) return false;
    if(search && !(d.product+d.vendor+(d.version||"")).toLowerCase().includes(search.toLowerCase())) return false;
    return true;
  });

  var expired  = data.filter(function(d){return d.is_eol;}).length;
  var soon     = data.filter(function(d){return !d.is_eol&&d.days_to_eol<=90;}).length;
  var ok       = data.filter(function(d){return !d.is_eol&&d.days_to_eol>90;}).length;

  var getDaysAging=function(d){
    if(!d.eol_date) return "—";
    var days=Math.floor((new Date()-new Date(d.eol_date))/(1000*60*60*24));
    return days>0?days+"d past EOL":"—";
  };

  var thS={padding:"10px 12px",textAlign:"left",fontSize:10,fontWeight:700,color:T.text3,
    textTransform:"uppercase",letterSpacing:.8,background:T.inset,borderBottom:"1px solid "+T.border,whiteSpace:"nowrap"};
  var tdS={padding:"10px 12px",fontSize:12,color:T.text,borderBottom:"1px solid "+T.border,verticalAlign:"middle"};

  if(loading) return React.createElement("div",{style:{color:T.text3,padding:40,textAlign:"center"}},"Loading EOL data...");

  return React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:14}},

    // Status cards - clickable to filter
    React.createElement("div",{style:{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:12}},
      [{key:"expired",label:"Expired EOL",val:expired,color:"#e5534b",sub:"Immediate action needed"},
       {key:"soon",   label:"Expiring <90d",val:soon,  color:"#d29922",sub:"Plan upgrade roadmap"},
       {key:"ok",     label:"OK",          val:ok,    color:"#2ea043",sub:"Within support lifecycle"},
      ].map(function(s){
        var active=filter===s.key;
        return React.createElement("div",{key:s.key,
          onClick:function(){setFilter(active?"all":s.key);},
          style:{background:T.card,border:"2px solid "+(active?s.color:T.border),borderRadius:12,
            padding:"16px 20px",cursor:"pointer",boxShadow:T.cardShadow,
            transition:"all .15s",outline:active?"none":"none"}},
          React.createElement("div",{style:{fontSize:28,fontWeight:800,color:s.color,marginBottom:2}},s.val),
          React.createElement("div",{style:{fontSize:13,fontWeight:600,color:T.text,marginBottom:2}},s.label),
          React.createElement("div",{style:{fontSize:11,color:T.text3}},s.sub)
        );
      })
    ),

    // Search + filter bar
    React.createElement("div",{style:{display:"flex",gap:8,alignItems:"center",flexWrap:"wrap"}},
      React.createElement("input",{placeholder:"Search product, vendor...",value:search,
        onChange:function(e){setSearch(e.target.value);},
        style:{flex:"1 1 200px",padding:"8px 12px",background:T.inset,border:"1px solid "+T.border,
          color:T.text,fontSize:13,outline:"none",borderRadius:8}}),
      React.createElement("div",{style:{fontSize:12,color:T.text3}},
        filtered.length+" of "+data.length+" products",
        filter!=="all"&&React.createElement("button",{onClick:function(){setFilter("all");},
          style:{marginLeft:8,background:"transparent",border:"none",color:PURPLE,cursor:"pointer",fontSize:11}},"Clear filter")
      )
    ),

    // Table
    React.createElement("div",{style:{background:T.card,borderRadius:12,overflow:"hidden",boxShadow:T.cardShadow}},
      React.createElement("table",{style:{width:"100%",borderCollapse:"collapse"}},
        React.createElement("thead",null,
          React.createElement("tr",null,
            ["Product","Description","Vendor","Version","Category","EOL Date","Days Aging","Status","Severity"].map(function(h){
              return React.createElement("th",{key:h,style:thS},h);
            })
          )
        ),
        React.createElement("tbody",null,
          filtered.length===0
            ? React.createElement("tr",null,React.createElement("td",{colSpan:9,style:{padding:32,textAlign:"center",color:T.text3}},"No products found"))
            : filtered.map(function(d,i){
                var aging=getDaysAging(d);
                var statusColor=d.is_eol?"#e5534b":d.days_to_eol<=90?"#d29922":"#2ea043";
                var statusLabel=d.is_eol?"Expired":d.days_to_eol<=90?"Expiring Soon":"Active";
                var sevColor={Critical:"#e5534b",High:"#e8892b",Medium:"#c69026",Low:"#2ea043"}[d.severity]||T.text3;
                return React.createElement("tr",{key:d.id,
                  style:{background:i%2===0?T.card:T.inset,transition:"background .1s"}},
                  React.createElement("td",{style:Object.assign({},tdS,{fontWeight:600,color:T.text})},d.product),
                  React.createElement("td",{style:Object.assign({},tdS,{color:T.text2,maxWidth:180,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"})},
                    d.description||d.vendor+" "+d.product+" end-of-life software"),
                  React.createElement("td",{style:tdS},d.vendor),
                  React.createElement("td",{style:Object.assign({},tdS,{color:T.text3})},d.version||"—"),
                  React.createElement("td",{style:tdS},
                    React.createElement("span",{style:{background:PURPLE+"18",color:PURPLE,padding:"2px 8px",borderRadius:20,fontSize:11,fontWeight:600}},d.category||"—")
                  ),
                  React.createElement("td",{style:tdS},d.eol_date?new Date(d.eol_date).toLocaleDateString():"—"),
                  React.createElement("td",{style:Object.assign({},tdS,{color:d.is_eol?"#e5534b":T.text3,fontWeight:d.is_eol?700:400})},aging),
                  React.createElement("td",{style:tdS},
                    React.createElement("span",{style:{background:statusColor+"20",color:statusColor,
                      padding:"3px 10px",borderRadius:20,fontSize:11,fontWeight:700}},statusLabel)
                  ),
                  React.createElement("td",{style:tdS},
                    React.createElement("span",{style:{background:sevColor+"20",color:sevColor,
                      padding:"3px 10px",borderRadius:20,fontSize:11,fontWeight:700}},d.severity||"—")
                  )
                );
              })
        )
      )
    )
  );
}


